import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { RouteSelectors } from "../../core/state/route/route.selectors";
import { PathAndParam } from "../../core/state/route/route.state";
import { EscalatingReportState } from "./state/missed-recall.reducer";

@Component({
  selector: "missed-recall-report-table",
  templateUrl: "missed-recall-report-table.component.html",
  styleUrls: ["missed-recall-report-table.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissedRecallReportTableComponent {
  @Input() report: EscalatingReportState;
  @Input() tableType: string;
  userRoute$: Observable<PathAndParam>;
  baseUrl: string;

  constructor(private router: Router, private routeSelectors: RouteSelectors) {
    this.userRoute$ = routeSelectors
      .selectRoutesPath()
      .pipe(map((routeData) => routeData.USER));

    this.baseUrl = document.location.origin;
  }

  setRoute(routePath, paramKey, paramArgument): void {
    const params = {};
    params[paramKey] = paramArgument;
    this.router.navigate([routePath], { queryParams: params });
  }
}
